import { buildApiUrl, Type, sendGetRequest } from '@/api/api';
import { assertSchemaAndCoerce } from '@/shared/utils/schemas/assertions'
import { z } from 'zod'

export const touSchema = z.object({
  Id: z.number(),
  Hour: z.number(),
  Week_h: z.string(),
  Saturday_h: z.string(),
  Sunday_h: z.string(),
  Week_l: z.string(),
  Saturday_l: z.string(),
  Sunday_l: z.string(),
  TimeOfUseProfileId: z.number(),
})

export const responseSchema = z.array(touSchema)

export async function fetchTOUProfileConfig(profileId: number) {
  const url = buildApiUrl(Type.TariffManagement, `time-of-use-config/${profileId}`)
  const { data } = await sendGetRequest(url)
  return assertSchemaAndCoerce(data, responseSchema)
}
